import { render, staticRenderFns } from "./NewPostModal.vue?vue&type=template&id=3098d80e&scoped=true&"
import script from "./NewPostModal.vue?vue&type=script&lang=js&"
export * from "./NewPostModal.vue?vue&type=script&lang=js&"
import style0 from "./NewPostModal.vue?vue&type=style&index=0&id=3098d80e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3098d80e",
  null
  
)

export default component.exports